import * as z from "zod/v4";
import { Provider } from "./order";

/**
 * This is the recommended product schema for the Redo platform.
 * It inherits its structure from the Shopify storefront API, but adds additional fields
 * that are specific to the Redo platform.
 */
export const redoRecommendedProductSchema = z.object({
  id: z.string(),
  title: z.string(),
  handle: z.string(),
  vendor: z.string(),
  onlineStoreUrl: z.string().optional().nullable(),
  totalInventory: z.number().optional().nullable(),
  description: z.string(),
  productType: z.string(),
  collections: z.object({
    nodes: z.array(z.object({ id: z.string(), title: z.string() })),
  }),
  availableForSale: z.boolean(),
  tags: z.array(z.string()),
  publishedAt: z.string(),
  options: z.array(
    z.object({ id: z.string(), name: z.string(), values: z.array(z.string()) }),
  ),
  featuredImage: z
    .object({ altText: z.string().optional().nullable(), url: z.string() })
    .optional()
    .nullable(),
  variants: z.object({
    nodes: z.array(
      z.object({
        id: z.string(),
        requiresShipping: z.boolean(),
        currentlyNotInStock: z.boolean(),
        availableForSale: z.boolean(),
        weight: z.number().optional().nullable(),
        weightUnit: z.string(),
        price: z.object({ amount: z.number(), currencyCode: z.string() }),
        sku: z.string().optional().nullable(),
        title: z.string(),
        selectedOptions: z.array(
          z.object({ name: z.string(), value: z.string() }),
        ),
        quantityAvailable: z.number().optional().nullable(),
        image: z.object({ url: z.string() }).optional().nullable(),
        compareAtPrice: z.string().optional().nullable(),
      }),
    ),
  }),
  images: z.object({
    nodes: z.array(
      z.object({
        altText: z.string().optional().nullable(),
        id: z.string().optional().nullable(),
        url: z.string().optional().nullable(),
      }),
    ),
  }),
  price: z.number(),
  altImage: z.object({
    url: z.string().optional().nullable(),
    altText: z.string().optional().nullable(),
  }),
  provider: z.enum(Provider),
});

export type RedoRecommendedProduct = z.infer<
  typeof redoRecommendedProductSchema
>;
